<!-- <template>
  <router-view/>
</template> -->

<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
    <CookiesPopup />
    <PrivacyPolicyModal />
  </div>
</template>


<script>
  import CookiesPopup from './pages/CookiesPopup.vue';
  import PrivacyPolicyModal from './pages/PrivacyPolicyModal.vue';
  export default {
    name: 'App',
    created() {
      const targetRoute = '';
      if (targetRoute) {
        // Redirect the user to the stored target route.
        this.$router.push(targetRoute);
      }
    },

    components: {
        CookiesPopup,
        PrivacyPolicyModal,
    },
  }
</script>

